export default "__VITE_ASSET__wrOyznIE__"